// extracted by mini-css-extract-plugin
module.exports = {"container":"Range_container__CywSF"};